var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFriends(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Friend list"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_1407_3715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 28C8 23.5817 11.5817 20 16 20C20.4183 20 24 23.5817 24 28H8ZM16 19C12.685 19 10 16.315 10 13C10 9.685 12.685 7 16 7C19.315 7 22 9.685 22 13C22 16.315 19.315 19 16 19ZM23.3628 21.2332C26.4482 22.0217 28.7679 24.7235 28.9836 28H26C26 25.3902 25.0002 23.0139 23.3628 21.2332ZM21.3401 18.9569C22.9728 17.4922 24 15.3661 24 13C24 11.5827 23.6314 10.2514 22.9849 9.09687C25.2753 9.55397 27 11.5746 27 14C27 16.7625 24.7625 19 22 19C21.7763 19 21.556 18.9853 21.3401 18.9569Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1407_3715",
    x1: 0,
    y1: 18,
    x2: 36,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFriends);
export default __webpack_public_path__ + "static/media/icon_friends.098dcc6d1596d6b935dd1b38aa5e273e.svg";
export { ForwardRef as ReactComponent };